export default __webpack_public_path__ + "static/media/metamask_icon_white.c024083b.png";